import { TranslocoService } from '@jsverse/transloco';
import { MenuItemWithIcon } from '../types/menu.interface';

export interface EntityMenuCallbacks {
  onEdit: () => void;
  onDuplicate?: () => void;
  onDelete: () => void;
  onExport?: () => void;
}

export interface EntityMenuOptions {
  // When false, edit / duplicate / delete entries are omitted. Defaults to true.
  // Export stays visible because it reads data and does not mutate state.
  canWrite?: boolean;
}

export function buildEntityMenuItems(
  translate: TranslocoService,
  translationPrefix: string,
  callbacks: EntityMenuCallbacks,
  options?: EntityMenuOptions,
): MenuItemWithIcon[] {
  const items: MenuItemWithIcon[] = [];
  const canWrite = options?.canWrite ?? true;

  if (callbacks.onExport) {
    items.push({
      label: translate.translate(`${translationPrefix}.export`),
      materialIcon: 'download',
      command: callbacks.onExport,
    });
  }

  if (canWrite) {
    items.push({
      label: translate.translate(`${translationPrefix}.edit`),
      materialIcon: 'edit',
      command: callbacks.onEdit,
    });
    if (callbacks.onDuplicate) {
      items.push({
        label: translate.translate(`${translationPrefix}.duplicate`),
        materialIcon: 'content_copy',
        command: callbacks.onDuplicate,
      });
    }
    items.push({
      label: translate.translate(`${translationPrefix}.delete`),
      materialIcon: 'delete',
      styleClass: 'p-menuitem-danger',
      command: callbacks.onDelete,
    });
  }

  return items;
}
